module.exports = __webpack_public_path__ + "media/images/global/icons/move-a427c2bd40f51e9749656ef743e9aa32.svg";